import { useState, useEffect } from 'react';
import { parseTimecode, formatTimecode } from '../../domain/time';

/**
 * A single editable timecode field, shared by the Redaction Studio and the
 * Excerpt Studio. Accepts typed h:mm:ss(.d), m:ss(.d) or raw seconds; commits
 * on Enter/blur; ↑/↓ nudge by 0.1s (Shift = 1s) and commit live so the
 * waveform/strip follows. Reverts to the canonical value on an unparseable
 * entry.
 */
export default function TimeField({ value, onCommit, ariaLabel, className = '' }) {
  const [draft, setDraft] = useState(formatTimecode(value));
  const [bad, setBad] = useState(false);
  useEffect(() => { setDraft(formatTimecode(value)); setBad(false); }, [value]);

  const commit = () => {
    const parsed = parseTimecode(draft);
    if (parsed == null) { setBad(true); setDraft(formatTimecode(value)); setBad(false); return; }
    onCommit(parsed);
  };
  const onKeyDown = (e) => {
    if (e.key === 'Enter') { e.target.blur(); return; }
    if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
      e.preventDefault();
      const step = e.shiftKey ? 1 : 0.1;
      const base = parseTimecode(draft);
      const cur = base == null ? value : base;
      onCommit(Math.max(0, cur + (e.key === 'ArrowUp' ? step : -step)));
    }
  };
  return (
    <input
      className={`rdx-time-field${bad ? ' rdx-time-field--bad' : ''}${className ? ` ${className}` : ''}`}
      value={draft}
      aria-label={ariaLabel}
      title="Type h:mm:ss, m:ss or seconds · ↑/↓ nudge 0.1s (Shift 1s)"
      onChange={e => setDraft(e.target.value)}
      onBlur={commit}
      onKeyDown={onKeyDown}
    />
  );
}
